import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-clinic-join-disclaimer',
    templateUrl: './clinic-join-disclaimer.component.html',
    styleUrls: ['./clinic-join-disclaimer.component.css'],
    standalone: false
})
export class ClinicJoinDisclaimerComponent {

  isChecked = false;

  constructor(protected activeModal: NgbActiveModal, private router: Router) { }

  decline() {
    this.activeModal.dismiss();
    this.router.navigate(['/']);
  }


}
